import Vue from 'vue'

import { createSimpleTransition } from 'vuetify/es5/util/helpers'
import CustomDialog from '@/components/generic/CustomDialog'
import OFadeTransition from '@/components/transitions/OFadeTransition'
import OScaleXTransition from '@/components/transitions/OScaleXTransition'
import ODatePicker from '@/components/generic/ODatePicker'
import ONumericTextField from '@/components/generic/ONumericTextField'
import NumericTextField from '@/components/generic/NumericTextField'
import OBigTitle from '@/components/generic/titulos/OBigTitle'
import OMediumTitle from '@/components/generic/titulos/OMediumTitle'
import OCommonTitle from '@/components/generic/titulos/OCommonTitle'
import ODescriptionTitle from '@/components/generic/titulos/ODescriptionTitle'
import OBaseCenterText from '@/components/generic/textos/OBaseCenterText'
import OBaseText from '@/components/generic/textos/OBaseText'
import OBaseJustifyText from '@/components/generic/textos/OBaseJustifyText'
import OMainProgress from '@/components/generic/OMainProgress'
import OThinTitle from '@/components/generic/titulos/OThinTitle'
import OSmallTitle from '@/components/generic/titulos/OSmallTitle'
import OBigLogo from '@/components/generic/OBigLogo'
import OBtnVolver from '@/components/generic/OBtnVolver'
import OTintImg from '@/components/generic/OTintImg'
import OSelectTodos from '@/components/generic/OSelectTodos'
import OMediumTitleErase from '@/components/generic/titulos/OMediumTitleErase'
import AddArrendatario from '@/components/generic/AddArrendatario'
import OMediumTitleCheckbox from '@/components/generic/titulos/OMediumTitleCheckbox'
import OMediumTitleDetail from '@/components/generic/titulos/OMediumTitleDetail'
import SelectPreLoadItem from '@/components/generic/SelectPreLoadItem'
import PopUpSeguro from '@/components/generic/PopUpSeguro'

import PopUpLayout from '@/layouts/PopUpLayout'
import PageLayout from '@/layouts/PageLayout'
import LogoLayout from '@/layouts/LogoLayout'

const slideYList = createSimpleTransition('slide-y-list')

Vue.component('slide-y-list', slideYList)

Vue.component('custom-dialog', CustomDialog)
Vue.component('o-fade-transition', OFadeTransition)
Vue.component('o-scale-x-transition', OScaleXTransition)
Vue.component('v-numeric-text-field', NumericTextField)
Vue.component('o-numeric-text-field', ONumericTextField)
Vue.component('o-date-picker', ODatePicker)
Vue.component('o-big-title', OBigTitle)
Vue.component('o-medium-title', OMediumTitle)
Vue.component('o-common-title', OCommonTitle)
Vue.component('o-description-title', ODescriptionTitle)
Vue.component('o-base-center-text', OBaseCenterText)
Vue.component('o-base-text', OBaseText)
Vue.component('o-base-justify-text', OBaseJustifyText)
Vue.component('o-main-progress', OMainProgress)
Vue.component('o-thin-title', OThinTitle)
Vue.component('o-small-title', OSmallTitle)
Vue.component('o-big-logo', OBigLogo)
Vue.component('o-btn-volver', OBtnVolver)
Vue.component('o-tint-img', OTintImg)
Vue.component('o-select-todos', OSelectTodos)
Vue.component('o-medium-title-checkbox', OMediumTitleCheckbox)
Vue.component('o-medium-title-detail', OMediumTitleDetail)
Vue.component('o-medium-title-erase', OMediumTitleErase)
Vue.component('add-arrendatario', AddArrendatario)
Vue.component('select-pre-load-item', SelectPreLoadItem)

Vue.component('pop-up-seguro', PopUpSeguro)
Vue.component('page-layout', PageLayout)
Vue.component('logo-layout', LogoLayout)
Vue.component('pop-up-layout', PopUpLayout)



// WEBPACK FOOTER //
// ./src/plugins/components.js